import { Badge } from "./ui/badge";
import { Link } from "react-router-dom";
import { useGames } from "../context/GamesContext";

export default function PlayerCard({ player }) {
  const { shortOf } = useGames();
  return (
    <Link
      to={`/roster/${(player.ign || player.id).toLowerCase()}`}
      data-testid={`player-card-${player.id}`}
      className="group relative overflow-hidden rounded-2xl bg-axe-surface border border-axe-border transition-transform duration-300 hover:-translate-y-1 hover:border-axe-purple/60 transform-gpu [backface-visibility:hidden] [will-change:transform] block"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-axe-surface">
        <img
          src={player.image}
          alt={player.ign}
          style={{ objectPosition: player.image_position || "50% 50%" }}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 transform-gpu [backface-visibility:hidden] [will-change:transform]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-axe-surface via-axe-surface/40 to-transparent" />
        <div className="absolute left-3 top-3">
          <Badge className="bg-axe-purple/90 text-white uppercase tracking-[0.18em] text-[10px] font-bold">
            {player.rank || "Pro"}
          </Badge>
        </div>
        {(player.secondary_games || []).length > 0 && (
          <div className="absolute right-3 top-3 flex gap-1">
            {player.secondary_games.slice(0, 3).map((g) => (
              <span
                key={g}
                title={`Also plays ${g}`}
                className="px-2 py-0.5 rounded-full text-[9px] uppercase tracking-[0.2em] font-bold bg-axe-tangerine/90 text-black"
                data-testid={`player-card-secondary-${g}`}
              >
                {shortOf(g)}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-display font-bold text-xl text-white truncate">{player.ign}</h3>
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-neutral-500">
            {player.country}
          </span>
        </div>
        <div className="mt-1 text-[11px] font-bold uppercase tracking-[0.3em] text-axe-tangerine">
          {player.role}
        </div>
        {player.bio && (
          <p className="mt-3 text-sm text-neutral-400 leading-relaxed line-clamp-2">
            {player.bio}
          </p>
        )}
      </div>
    </Link>
  );
}
